import CollapsibleSection from './CollapsibleSection';

export default function DetailVariant({ values }) {
  const variantExternalLink = values?.strID ? `https://www.ncbi.nlm.nih.gov/snp/${values.strID}` : '';
  const gnomadExternalLink = values?.strID
    ? `https://gnomad.broadinstitute.org/variant/${values.strID}?dataset=gnomad_r4`
    : '';
  return (
    <div className="space-y-0">
      <CollapsibleSection title="General Info" defaultOpen>
        <table className="table table-sm mb-0">
          <tbody>
            <tr>
              <td>
                <strong>SNP Identifier: </strong>
              </td>
              <td>{values.strID}</td>
            </tr>
            <tr>
              <td>
                <strong>Class: </strong>
              </td>
              <td>{values.DBSNPclass}</td>
            </tr>
            <tr>
              <td>
                <strong>Gene Symbol: </strong>
              </td>
              <td>
                {values.variantToGenes.map(
                  (value, index, array) => ` ${value.geneSymbol} ${index === array.length - 1 ? '' : ';'}`,
                )}
              </td>
            </tr>
            <tr>
              <td>
                <strong>Chromosome: </strong>
              </td>
              <td>{values.chromosome}</td>
            </tr>
            <tr>
              <td>
                <strong>Consequence: </strong>
              </td>
              <td>{values.mostSevereConsequences}</td>
            </tr>
            <tr>
              <td>
                <strong>DPI: </strong>
              </td>
              <td>{typeof values.DPI === 'number' ? values.DPI?.toFixed(2) : ''}</td>
            </tr>
            <tr>
              <td>
                <strong>DSI: </strong>
              </td>
              <td>{typeof values.DSI === 'number' ? values.DSI?.toFixed(2) : ''}</td>
            </tr>
            <tr>
              <td>
                <strong>Amino acid change: </strong>
              </td>
              <td>
                {values.threeletterID.map(
                  (value, index, array) => ` ${value} ${index === array.length - 1 ? '' : ';'}`,
                )}
              </td>
            </tr>
            {variantExternalLink && (
              <tr>
                <td>
                  <strong>External links: </strong>
                </td>
                <td className="flex flex-col gap-2">
                  <a
                    href={variantExternalLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tab-links"
                  >
                    View in dbSNP <i className="fa fa-external-link" aria-hidden="true"></i>
                  </a>
                  <a
                    href={gnomadExternalLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tab-links"
                  >
                    View in GNOMAD <i className="fa fa-external-link" aria-hidden="true"></i>
                  </a>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </CollapsibleSection>
    </div>
  );
}
